/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable sort-keys */
import { darken, lighten, rgba } from 'polished';
import Theme from '../types/theme';
import { decrease, increase } from '../colors/chartPalette';
import { designTokens } from '../tokens';
import * as colorPalette from '../colors/defaultPalette';

const { colorPalette: designTokensColorPalette } = designTokens;

const themePalette = {
  bloombergBurgundy: '#9F0D20',
  bloombergDarkGrey: '#2B2B2B',
  bloombergGreen: '#18BE39',
  bloombergGreenDark: '#13982e',
  bloombergGreenDarker: '#0e7222',

  bloombergGreenLight: '#46cb61',
  bloombergGreenLighter: '#74d888',
  bloombergGrey: '#9B9B9B',
  bloombergLightGrey: '#A9A9A9',
  bloombergMediumGrey: '#424242',

  bloombergOrange: '#A56300',
  bloombergOrangeDark: '#844f00',
  bloombergOrangeDarker: '#633b00',
  bloombergOrangeLight: '#b78233',
  bloombergOrangeLighter: '#c9a166',

  bloombergYellow: '#FF9C29',
  bloombergYellowDark: '#cc7d21',
  bloombergYellowDarker: '#995e19',
  bloombergYellowLight: '#ffb054',
  bloombergYellowLighter: '#ffc47f',
};

const colors = {
  accent: themePalette.bloombergYellow,
  accentDark: themePalette.bloombergYellowDark,
  accentDarker: themePalette.bloombergYellowDarker,
  accentForeground: '#000000',
  accentLight: themePalette.bloombergYellowLight,
  accentLighter: themePalette.bloombergYellowLighter,
  accentMuted: darken(0.1, themePalette.bloombergYellow),

  actionDisabled: rgba(colorPalette.neutral500, 0.8),
  actionDisabledBackground: rgba(colorPalette.neutral500, 0.24),
  actionFocus: rgba(colorPalette.neutral500, 0.24),
  actionHover: rgba(colorPalette.neutral500, 0.08),
  actionSelected: rgba(colorPalette.neutral500, 0.16),

  background: '#000000',
  backgroundActive: '#000000',
  backgroundInactive: themePalette.bloombergMediumGrey,

  banner: '#11141A',

  blindMode: 'none',

  border: colorPalette.greyDarker,
  borderDark: colorPalette.greyDarker,
  borderLight: colorPalette.grey,
  borderUnified: colorPalette.greyDarkest,

  brand: themePalette.bloombergOrange,
  brandDark: themePalette.bloombergOrangeDark,
  brandDarker: themePalette.bloombergOrangeDarker,
  brandUnified: themePalette.bloombergOrangeDark,

  brandForeground: '#ffffff',
  brandLight: themePalette.bloombergOrangeLight,
  brandLighter: themePalette.bloombergOrangeLighter,
  brandMuted: darken(0.1, themePalette.bloombergOrange),

  buttonPrimary: designTokensColorPalette.blue500,
  buttonPrimaryBackground: designTokensColorPalette.blue200,
  buttonPrimaryBackgroundHover: designTokensColorPalette.blue200,
  buttonPrimaryBorder: designTokensColorPalette.blue500,
  buttonPrimaryUnified: designTokensColorPalette.white,
  buttonPrimaryBackgroundUnified: designTokensColorPalette.bzOrangeDarker,

  danger: 'red',
  dangerDark: 'red',
  dangerDarker: 'red',
  dangerForeground: colorPalette.white,
  dangerLight: 'red',
  dangerLighter: 'red',

  dropdownBackground: themePalette.bloombergOrange,
  dropdownBackgroundActive: themePalette.bloombergDarkGrey,

  foreground: themePalette.bloombergYellow,
  foregroundActive: lighten(0.5, themePalette.bloombergYellow),
  foregroundInactive: lighten(0.1, themePalette.bloombergYellow),
  foregroundMuted: lighten(0.05, themePalette.bloombergYellow),

  information: themePalette.bloombergOrange,

  statistic: {
    negative: 'red',
    neutral: '#ffffff',
    positive: themePalette.bloombergGreen,
  },

  success: themePalette.bloombergGreen,
  successDark: themePalette.bloombergGreenDark,
  successDarker: themePalette.bloombergGreenDarker,
  successForeground: colorPalette.white,
  successLight: themePalette.bloombergGreenLight,
  successLighter: themePalette.bloombergGreenLighter,

  warning: 'yellow',
  warningDark: 'yellow',
  warningDarker: 'yellow',
  warningForeground: colorPalette.white,
  warningLight: 'yellow',
  warningLighter: 'yellow',
};

const chart = {
  color: {
    accentColor1: 'rgba(73, 83, 96, .3)',
    accentColor2: 'rgba(73, 83, 96, 1)',
    mainColor: 'rgba(255, 255, 255, 1)',
    periods: {
      decrease,
      increase,
    },
    tooltipBackground: 'rgba(0, 0, 0, 1)',
  },
};

const antique: Partial<Theme> = {
  chart,
  colors: colors,
  name: 'antique',
};

export default antique;
